module.exports = __webpack_public_path__ + "static/media/how-to-measure-matboard-windows.5dd39d9d.png";